<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="1" @click="$router.push('witSite')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('applySafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('applyCartoon')">工程动画</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="bo" v-for="item in dataList" :key="item.id" @click="carClick(item.id)">
                <img :src="item.img"  width="100%" height="100%">
                <div>
                    <span>{{item.title}}</span>
                </div>
            </div>
            <div style="clear:left"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ApplySafety",
        data(){
            return{
                idx: '3',
                dataList:[
                    {id:1,img:require('../../assets/images/apply/car/ds1.jpg'),title:'深圳地铁红树湾物业开发项目'},
                    {id:2,img:require('../../assets/images/apply/car/ds2.jpg'),title:'中建三局投标动画'},
                    {id:3,img:require('../../assets/images/apply/car/ds3.jpg'),title:'华润深圳湾国际投标动画'},
                    {id:4,img:require('../../assets/images/apply/car/ds4.jpg'),title:'安全生产警示片-高处坠落案例'},
                    {id:5,img:require('../../assets/images/apply/car/ds5.jpg'),title:'潍坊白浪河大桥摩天轮施工动画演示'},
                    {id:6,img:require('../../assets/images/apply/car/ds6.jpg'),title:'中建ASTAK施工动画'},
                    {id:7,img:require('../../assets/images/apply/car/ds7.jpg'),title:'水电站投标动画'},
                    {id:8,img:require('../../assets/images/apply/car/ds8.jpg'),title:'中建钢构投标动画'},
                    {id:9,img:require('../../assets/images/apply/car/ds9.jpg'),title:'平安大厦超高层施工动画'}
                ]
            }
        },
        methods:{
            carClick(id){
                sessionStorage.setItem('carCode3',id);
                this.$router.push('applyCarDetail');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/apply/al.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 6.24rem;
        margin: .34rem auto .6rem;
        text-align: center;
        a{
            text-decoration:none;
        }
        .el-menu-item{
            width:2.08rem;
            font-size: .2rem;
            height: .72rem;
            line-height: .72rem;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 3px solid #E70F20;
            color: #E70F20;
        }
        .el-menu--horizontal>.el-menu-item {
            color:#000;
        }
    }
    .box3{
        width: 12rem;
        margin:0 auto;
        div.bo{
            position: relative;
            width:4rem;
            height:2.5rem;
            float: left;
            div{
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height: 100%;
                font-size: .2rem;
                color:#fff;
                text-align: center;
                line-height: 2.5rem;
                background: rgba(231,15,32,0.6);
                display: none;
                span{
                    position: relative;
                }
                span::before{
                    position: absolute;
                    content:"";
                    background: #fff;
                    width: 2px;
                    height: .14rem;
                    top:.05rem;
                    left:-.1rem;
                }
            }
        }
        div.bo:hover{
            div{
                display: block;
            }
        }
    }
</style>
